'use strict';

const $ = window.jQuery;

export default class Newsroom {
    constructor() {
        if ($('body').hasClass('blog')) {
            let footerHeight = $('.nr-footer').innerHeight();

            if ($(window).width() > 767) {
                $('.newsroom').css('margin-bottom', footerHeight - 8);
            }

            $(window).on('scroll', function () {
                let scroll = $(window).scrollTop() - 700;

                $('.nr-top-parallax, .nr-left-parallax, .nr-right-parallax').css({
                    'transform': `translateY(-${scroll / 3}px)`
                });
            });

            $(document).on('facetwp-loaded', function () {
                $('.nr-filters').removeClass('is-loading');

                // Checkboxes status
                if (FWP.facets.post_categories.length) {
                    $('.nr-filters__reset').removeClass('checked');
                } else {
                    $('.nr-filters__reset').addClass('checked');
                }

                if ($('.fwp-load-more').length) {
                    $('.facet-more-loading').hide();
                    $('.fwp-load-more').show();
                }

                if (FWP.settings.pager.page < FWP.settings.pager.total_pages) {
                    $('.fwp-load-more').show();
                }
                else {
                    $('.fwp-load-more').hide();
                }
            });

            $(document).on('facetwp-refresh', function () {
                $('.nr-filters').addClass('is-loading');
                $('.fwp-load-more').hide();
                $('.facet-more-loading').show();
            });
        }

        if ($('body').hasClass('single-post')) {
            let footerHeight = $('.nr-footer').innerHeight();

            if ($(window).width() > 767) {
                $('.single-newsroom').css('margin-bottom', footerHeight - 8);
            }
        }
    }
}
